export const isAppleOS = () => {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return /Mac|iPhone|iPad|iPod/i.test(ua)
}
